import { render, staticRenderFns } from "./cgd-index.vue?vue&type=template&id=01c0a32e&scoped=true"
import script from "./cgd-index.vue?vue&type=script&lang=js"
export * from "./cgd-index.vue?vue&type=script&lang=js"
import style0 from "./cgd-index.vue?vue&type=style&index=0&id=01c0a32e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0a32e",
  null
  
)

export default component.exports